// extracted by mini-css-extract-plugin
export var container = "_hr-0";
export var content = "_hr-3";
export var customerTitle = "_hr-4";
export var empty = "_hr-5";
export var gray = "_hr-6";
export var header = "_hr-7";
export var info = "_hr-8";
export var loading = "_hr-2";
export var loadingCard = "_hr-9";
export var oneLine = "_hr-a";
export var personName = "_hr-e";
export var pillContainer = "_hr-b";
export var selected = "_hr-1";
export var text = "_hr-c";
export var twoLines = "_hr-d";
export var unread = "_hr-f";
export var unreadIndicator = "_hr-g";